import type React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@heroui-pro/react';
import { Icon } from '@iconify/react';
import { getNodeTestProps } from '@/utils';

/**
 * Shared "coming soon" placeholder for management features without a real page
 * yet. Render-only and feature-agnostic — the app shell navbar already shows
 * the feature name (resolved from the matched nav item), so the body just says
 * it's on the way. One stub serves every management route.
 */
export const ComingSoon: React.FC = () => {
    const { t } = useTranslation('pages');

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestProps('coming-soon-page')}
        >
            <div
                className="flex min-h-60 items-center justify-center rounded-2xl border border-border bg-surface"
                {...getNodeTestProps('coming-soon-body')}
            >
                <EmptyState>
                    <EmptyState.Header>
                        <EmptyState.Media variant="icon">
                            <Icon icon="solar:hourglass-line-duotone" />
                        </EmptyState.Media>
                        <EmptyState.Title>
                            {t('comingSoon.title')}
                        </EmptyState.Title>
                        <EmptyState.Description>
                            {t('comingSoon.subtitle')}
                        </EmptyState.Description>
                    </EmptyState.Header>
                </EmptyState>
            </div>
        </div>
    );
};
